var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10.6663V13.9996C14.6667 14.1764 14.5964 14.346 14.4714 14.471C14.3464 14.596 14.1768 14.6663 14 14.6663H2C1.82319 14.6663 1.65362 14.596 1.5286 14.471C1.40357 14.346 1.33333 14.1764 1.33333 13.9996V10.6663H0V13.9996C0 14.53 0.210714 15.0387 0.585787 15.4138C0.960859 15.7889 1.46957 15.9996 2 15.9996H14C14.5304 15.9996 15.0391 15.7889 15.4142 15.4138C15.7893 15.0387 16 14.53 16 13.9996V10.6663H14.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98046 7.58212e-06C7.71792 -0.000716153 7.45782 0.0503789 7.21506 0.150364C6.9723 0.25035 6.75167 0.39726 6.56579 0.582674L3.95312 3.19534L4.89579 4.13801L7.31846 1.71601L7.33579 12.6667H8.66913L8.65179 1.72534L11.0645 4.13801L12.0071 3.19534L9.39446 0.582674C9.20871 0.39728 8.98819 0.250377 8.74554 0.15039C8.50289 0.0504032 8.2429 -0.000701231 7.98046 7.58212e-06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSignature);
export default __webpack_public_path__ + "static/media/upload-signature.9adf1b771aeacacc80c230cdb7cada5a.svg";
export { ForwardRef as ReactComponent };